module.exports = __webpack_public_path__ + "static/bureau-3d43a7670982cbad954653db558439e2.jpg";